import { LoadingButton } from "@mui/lab";
import {
  Box,
  Divider,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import CustomDialog from "components/CustomDialog";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "store";
import { updateGlobalOfferMachinesThunk } from "store/reducers/global_offers/globalOffersSlice";
import { getMinMachinesThunk } from "store/reducers/vending";

const GlobalOffersMachineList = ({ open, handleClose, item }) => {
    // console.log(item);
  useEffect(() => {
    dispatch(getMinMachinesThunk());
  }, []);

  const machines = useSelector((state) => state.vending.minMachines);
  const [selectedMachines, setSelectedMachines] = useState(
    item.associated_machine.map((mc) => mc.id)
  );
//   useEffect(() => {
//     setSelectedMachines(item.associated_machine.map((mc) => mc.id));
//   }, [item]);
  const updateMachines = () => {
    dispatch(
      updateGlobalOfferMachinesThunk({
        id: item.id,
        data: { machines: selectedMachines },
      })
    );
  };

  const { status } = useSelector((state) => state.globalOffers);
  return (
    <CustomDialog
      open={open}
      handleClose={handleClose}
      heading="Offer applied to following machines"
    >
      <Box sx={{ margin: 2, minWidth: 400 }}>
        <TableContainer>
          <Table aria-label="machine table" size="small">
            <TableHead>
              <TableRow>
                <TableCell>ID </TableCell>
                <TableCell align="center">Machine name </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {item.associated_machine.map((machine) => (
                <TableRow
                  key={machine.id}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell align="left" component="th" scope="row">
                    {machine.id}
                  </TableCell>
                  <TableCell align="center" component="th" scope="row">
                    {machine.name}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Divider />
        <Box sx={{ mt: 4 }}>
          <TextField
            label="Update machines"
            variant="outlined"
            name="associated_machine"
            select
            SelectProps={{
              multiple: true,
              value: selectedMachines,
              onChange: (e) => setSelectedMachines(e.target.value),
            }}
            fullWidth
            autoComplete="new-password"
            required
          >
            {machines.map((machine) => (
              <MenuItem key={machine.id} value={machine.id}>
                {machine.name}
              </MenuItem>
            ))}
          </TextField>
          <LoadingButton
            variant="contained"
            type="submit"
            sx={{ paddingX: 10, marginTop: 1 }}
            loading={status?.loading === "update"}
            onClick={updateMachines}
          >
            Update
          </LoadingButton>
        </Box>
      </Box>
    </CustomDialog>
  );
};

export default GlobalOffersMachineList;
